var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssignSchedule = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 14,
    viewBox: "0 0 15.999 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1188.746 -364.761)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.934,
    height: 2.315,
    transform: "translate(-1185.321 364.761)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.934,
    height: 2.315,
    transform: "translate(-1178.935 364.761)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.474,
    height: 0.934,
    transform: "translate(-1183.945 365.452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1187.812,368.506h12.155v4.2h.932v-7.2h-2.718v.932h1.786v1.138h-12.155v-1.138h1.914V365.5h-2.849v12.671h7.885v-.932h-6.951Z",
    transform: "translate(0 -0.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1186.104 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1186.104 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1186.104 371.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1186.104 371.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1186.104 374.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1183.705 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1183.705 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1183.705 371.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1183.705 371.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1183.705 374.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1181.308 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1181.308 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1181.308 371.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1181.308 371.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.199,
    height: 1.199,
    transform: "translate(-1178.911 369.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.212,
    height: 1.212,
    transform: "translate(-1178.911 369.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1156.69,406.209l-2.6-2.6.8-.8,1.8,1.8,3.6-3.6.8.8Z",
    transform: "translate(-20.457 -27.448)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssignSchedule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/assign-schedule.e824aa4422a8db480d68b8f8841763ca.svg";